import React from "react";
import { Admin, Resource } from "react-admin";

import { myDataProvider } from "../dataProvider/dataProvider";
import adminRoutes from "./layout/adminRoutes";

import { AdminLayout } from "./layout/AdminLayout";
import { AdminDashboard } from "./layout/AdminDashboard";

import { ReloadYardList } from "./resources/reloadYards/ReloadYardList";
import { MyYardShow } from "../managerApp/resources/reloadYard/ReloadYardShow";
import { MyYardEdit } from "../managerApp/resources/reloadYard/ReloadYardEdit";

import SetupList from "./resources/registrations/SetupList";
import SetupShow from "./resources/registrations/SetupShow";
import SetupEdit from "./resources/registrations/SetupEdit";

import { LogList } from "./resources/logs/LogList";
import { LogShow } from "./resources/logs/LogShow";
import { LogEdit } from "./resources/logs/LogEdit";

import { UserList } from "../managerApp/resources/users/UserList";
import { UserEdit } from "../managerApp/resources/users/UserEdit";
import { UserShow } from "../managerApp/resources/users/UserShow";

import { AnnouncementCreate } from "./resources/announcements/AnnouncementCreate";
import { AnnouncementList } from "./resources/announcements/AnnouncementList";
import { AnnouncementEdit } from "./resources/announcements/AnnouncementEdit";
import { AnnouncementShow } from "./resources/announcements/AnnouncementShow";

import { AssetTypeEdit } from "../managerApp/resources/assetTypes/AssetTypeEdit";
import { EventTypeEdit } from "../managerApp/resources/eventTypes/EventTypeEdit";
import { ChecklistEdit } from "../managerApp/resources/checklists/ChecklistEdit";

import { CommodityList } from "./resources/commoditys/CommodityList";
import { CommodityEdit } from "./resources/commoditys/CommodityEdit";
import { CommodityCreate } from "./resources/commoditys/CommodityCreate";

import { HelpPageList } from "./resources/helpPages/HelpPageList";
import { HelpPageCreate } from "./resources/helpPages/HelpPageCreate";
import { HelpPageEdit } from "./resources/helpPages/HelpPageEdit";

import { useThemeState } from "../ThemeStateProvider";

export const AdminApp = ({ adminHistory }) => {
  const { selectedTheme } = useThemeState();

  return (
    <Admin
      disableTelemetry
      title="Transloads.co"
      dashboard={AdminDashboard}
      options={{ authGroups: [] }}
      dataProvider={myDataProvider}
      customRoutes={adminRoutes}
      layout={AdminLayout}
      theme={selectedTheme}
      history={adminHistory}
    >
      <Resource
        name="commoditys"
        create={CommodityCreate}
        list={CommodityList}
        edit={CommodityEdit}
      />
      <Resource
        name="setupDatas"
        list={SetupList}
        show={SetupShow}
        edit={SetupEdit}
      />
      <Resource
        name="reloadYards"
        show={MyYardShow}
        edit={MyYardEdit}
        list={ReloadYardList}
      />
      <Resource title={"Asset Types"} name="assetTypes" edit={AssetTypeEdit} />
      <Resource title={"Event Types"} name="eventTypes" edit={EventTypeEdit} />
      <Resource title={"Checklists"} name="checklists" edit={ChecklistEdit} />
      <Resource name="users" list={UserList} show={UserShow} edit={UserEdit} />
      <Resource
        name="announcements"
        create={AnnouncementCreate}
        list={AnnouncementList}
        edit={AnnouncementEdit}
        show={AnnouncementShow}
      />
      <Resource
        name="helpPages"
        list={HelpPageList}
        create={HelpPageCreate}
        edit={HelpPageEdit}
      />
      <Resource name="logs" list={LogList} show={LogShow} edit={LogEdit} />
    </Admin>
  );
};
